<script lang="ts" setup>
import { computed } from "vue";
import { OrderStopType } from "@/constants/order";
import OrderRefs from "@/components/order/OrderRefs.vue";
import TruckRouteStop from "@/components/truck/TruckRouteStop.vue";
import { useFilters } from "@/composables";
import BookedBy from "@/components/user/BookedBy.vue";
import type { TruckRoute } from "@/api/trucks/dto/truck.dto";

const { miles } = useFilters();

const props = defineProps<{
  route: TruckRoute;
}>();

const order = computed(() => {
  return props.route.travelOrders[0].order;
});

const firstPickUp = computed(() => {
  return props.route.routeStops.find((routeStop) => routeStop.type == OrderStopType.pickup);
});

const lastDelivery = computed(() => {
  return props.route.routeStops[props.route.routeStops.length - 1];
});
</script>

<template>
  <div class="pa-4 bg-grey-lighten-4">
    <div class="d-flex">
      <router-link
        :to="{ name: 'order-view', params: { id: order.id } }"
        class="text-decoration-none text-primary font-size-14 font-weight-500"
        data-qa="order-number"
        target="_blank"
      >
        Order #{{ order.number }}
      </router-link>

      <div class="d-flex text-grey-darken-1 ml-6">
        <span class="text-grey-navy font-weight-500">REF: </span>
        <div class="ml-2 d-flex">
          <order-refs :refs="order.refNumbers" ref-class="text-grey-navy font-weight-500"></order-refs>
        </div>
      </div>

      <booked-by v-if="order.bookedBy && order.id" :booked-by="order.bookedBy" :order-id="order.id" class="ml-6" />
    </div>

    <v-row class="mt-2">
      <v-col v-if="firstPickUp" cols="6">
        <truck-route-stop :route-stop="firstPickUp" route-stop-title="First pick up" />
      </v-col>

      <v-col v-if="lastDelivery" cols="6">
        <truck-route-stop :route-stop="lastDelivery" route-stop-title="Last delivery" />
      </v-col>

      <div class="d-flex justify-end w-100">
        <div class="text-grey-darken-1 mr-1">Empty miles:</div>
        <div>{{ miles(route.emptyMiles) || 0 }} miles</div>
      </div>
    </v-row>
  </div>
</template>

<style></style>
